package com.anjuros.website.redesign.theme

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba

/** Colours for the redesign, built from the Anjuros logo (sky blue #B4C6DC and graphite grey). */
object RdColor {
    val Ground: CSSColorValue = rgb(245, 247, 250)
    val Paper: CSSColorValue = rgb(255, 255, 255)
    val Ink: CSSColorValue = rgb(30, 40, 52)
    val Muted: CSSColorValue = rgb(95, 99, 104)
    val Line: CSSColorValue = rgb(220, 227, 236)
    val Brand: CSSColorValue = rgb(46, 75, 110)
    val BrandInk: CSSColorValue = rgb(255, 255, 255)
    val LogoBlue: CSSColorValue = rgb(180, 198, 220)
    val SkySoft: CSSColorValue = rgb(230, 237, 245)
    val Band: CSSColorValue = rgb(34, 54, 79)
    val BandText: CSSColorValue = rgb(238, 243, 248)
    val BandMuted: CSSColorValue = rgb(180, 198, 220)
    val HeaderGlass: CSSColorValue = rgba(245, 247, 250, 0.88)
}

object RdFont {
    // Name lists for Modifier.fontFamily, and the same stacks as CSS strings for `font` shorthands.
    val DISPLAY = arrayOf("Archivo", "Arial Narrow", "system-ui", "sans-serif")
    val BODY = arrayOf("Instrument Sans", "system-ui", "-apple-system", "Segoe UI", "sans-serif")
    val MONO = arrayOf("JetBrains Mono", "ui-monospace", "Consolas", "monospace")

    const val DISPLAY_STACK = "\"Archivo\", \"Arial Narrow\", system-ui, sans-serif"
    const val BODY_STACK = "\"Instrument Sans\", system-ui, -apple-system, \"Segoe UI\", sans-serif"
    const val MONO_STACK = "\"JetBrains Mono\", ui-monospace, Consolas, monospace"
}

object RdSize {
    const val SHADOW = "0 18px 40px -22px rgba(30,40,52,.45)"
    const val SECTION_PADDING = "clamp(64px, 8vw, 104px)"
    const val SIDE_GUTTER = "clamp(16px, 4vw, 32px)"
    const val MAX_WIDTH_PX = 1180
}
